import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";

import "./index.css";
import "./selectSearch.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
//import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import * as serviceWorker from './serviceWorker';
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <HashRouter basename="/asset">
    <App />
  </HashRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.register();
serviceWorker.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
